import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden">
      <img
        src="/images/cta.jpg"
        alt="Rénovation salle de bain Valais"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-xl">
          <span className="inline-block mb-4 px-3 py-1 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Parlons-en
          </span>
          <h2 className="text-4xl font-bold text-white leading-tight mb-4">
            Un projet en tête ?
          </h2>
          <p className="text-white/70 text-sm leading-relaxed mb-8">
            On ne vend pas de formules miracles. On vient chez vous, on regarde l'espace, on discute de ce qui est possible, et on vous dit franchement ce qu'on en pense. C'est comme ça qu'on travaille depuis 20 ans.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              Envoyer un message
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-medium rounded-full hover:bg-white/20 transition-colors whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}